import React, { useEffect } from "react";
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Spin,
  InputNumber,
  Divider,
  Space,
  Descriptions,
  Button,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
const { Text, Title } = Typography;

const DetailForm = (props) => {
  const {
    onSearch,
    searchParam,
    customerInfo,
    showDetailsForm,
    handleSearchInTable,
    onFinish,
    form,
    initialValues,
    onChangeProduct,
    productData,
    fieldOfficerData,
    isProductSelected,
  } = props;

  const dateFormat = "DD-MM-YYYY";

  useEffect(() => {
    defaultDate();
  }, []);

  const defaultDate = () => {
    form.setFieldsValue({
      submittedOnDate: dayjs(),
    });
  };

  const items = [
    {
      label: labelConfig.customerType,
      children: customerInfo ? customerInfo.entityType : "-",
    },
    {
      label: labelConfig.customerName,
      children: customerInfo ? customerInfo.entityName : "-",
    },
    {
      label: labelConfig.mobileNumber,
      children: customerInfo ? customerInfo.entityMobileNo : "-",
    },
    {
      label: labelConfig.customerNumber,
      children: customerInfo ? customerInfo.entityAccountNo : "-",
    },
  ];

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.customerInfo}
          </Title>
        </Divider>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Space.Compact
            style={{
              width: "100%",
            }}
          >
            <div>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Client:  Number / Mobile Number"
                style={{ width: 400 }}
                allowClear
              />
            </div>
            <Button
              type="primary"
              className="of-primaryBtnColor"
              onClick={onSearch}
            >
              <SearchOutlined />
            </Button>
          </Space.Compact>
        </Col>
      </Row>
      {showDetailsForm && (
        <>
          <Divider />
          <Descriptions
            bordered
            column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
            style={{ marginTop: 10, marginBottom: 20 }}
            items={items}
          />

          <Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.product}
                name={"productId"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.product),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.product,
                    "select"
                  )}
                  options={productData}
                  showSearch
                  onChange={onChangeProduct}
                />
              </Form.Item>
            </Col>
            {isProductSelected && (
              <>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.accountOfficer}
                    name={"fieldOfficerId"}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.accountOfficer,
                        "select"
                      )}
                      options={fieldOfficerData}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.currency} name={"currencyName"}>
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.currency
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.decimalPlaces}
                    name={"decimalPlaces"}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.decimalPlaces
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.currencyInMultiplesOf}
                    name={"inMultiplesOf"}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.currencyInMultiplesOf
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.createdDate}
                    name="submittedOnDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.createdDate),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={BOM.DisabledAfterCurrentDate}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.createdDate,
                        "select"
                      )}
                      style={{ width: "100%", height: 35 }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </Form>
  );
};

export default DetailForm;
